module.exports = "/assets/tech_for_uk_logo-4856e3f1ee440f04160da1aeb91b93ba.png";